import { Badge } from "@/components/ui/badge";
import type { CaseStatus } from "@/features/cases/types";

// Semantic-token classes per status (no hardcoded hex — see index.css tokens).
const STATUS_CLASS: Record<CaseStatus, string> = {
  PROSPECT: "bg-muted text-muted-foreground",
  ACTIVE: "bg-info/15 text-info",
  PENDING_IRS: "bg-warning/15 text-warning",
  ON_HOLD: "bg-gold/15 text-gold-foreground",
  RESOLVED: "bg-success/15 text-success",
  CLOSED: "bg-muted text-muted-foreground",
};

export function CaseStatusBadge({
  status,
  label,
}: {
  status: CaseStatus;
  label: string;
}) {
  return (
    <Badge
      variant="outline"
      className={`border-transparent text-[10px] font-bold uppercase ${STATUS_CLASS[status]}`}
    >
      {label}
    </Badge>
  );
}
